// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import xOrderInformationStyles from "@guestsupply/App/SharedStyles/MyAccountPages/Details/OrderInformationStyles";
import { currentShippingAddressStyles } from "@guestsupply/Overrides/Widgets/Addresses/CurrentShippingAddress";
import { createLinkIconStyles, mergeWithCss, xScreen } from "@guestsupply/XDL/Utilities";
import Edit from "@insite/mobius/Icons/Edit";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { css } from "styled-components";

// XNG-Changes: GSS-355
currentShippingAddressStyles.headingGridItem = {
    width: [10, 10, 9, 10, 10],
    css: css`
        align-items: baseline;
        gap: 10px;
    `,
};

currentShippingAddressStyles.editLinkGridItem = {
    width: [2, 2, 3, 2, 2],
    css: css`
        justify-content: end;
    `,
};

// GSS
currentShippingAddressStyles.useBillingAddress = {
    button: {
        variant: "primary",
        css: css`
            margin-top: 20px;
        `,
    },
};

// XNG-Changes: GSS-355
currentShippingAddressStyles.editLink = {
    ...createLinkIconStyles(Edit, {
        typographyProps: {
            size: 12,
            css: css`
                ${xScreen("lte", "md")} {
                    white-space: nowrap;
                }
            `,
        },
        icon: {
            iconProps: {
                size: 13,
                color: "primary",
                css: css`
                    margin-right: 4px;
                    opacity: 0.33;
                `,
            },
            position: "left",
        },
    }),
};

// XNG-Changes
currentShippingAddressStyles.headingText = {
    variant: "h5",
    css: css`
        margin-bottom: 0;
    `,
};
// XNG-Changes: GSS-355
currentShippingAddressStyles.addressFormModal = { sizeVariant: "large" };

// XNG-Changes
currentShippingAddressStyles.divider = {
    ...xOrderInformationStyles.address?.divider,
};
